// extracted by mini-css-extract-plugin
module.exports = {"turboProfileContainer":"_1DCJGsrg","bodyBold":"p_jif7-o","profileColumn":"_2mUV99rU","profileSectionWrapper":"_3REeP_ZW","screenshotView":"_13tI7bs_","dataColumnGroup":"_1ZFoRrJO","executiveSummaryColumn":"_18yzF4aw","professionalSummaryColumn":"_1ke3w7p_","hirewellLogo":"_3q93p9bI"};
    if(module.hot) {
      // 1746735832563
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  